var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1014 41.0883H31.4704C32.0277 41.0883 32.5622 40.8717 32.9563 40.4862C33.3504 40.1007 33.5718 39.5778 33.5718 39.0325V3.05581C33.5718 2.51058 33.3504 1.98767 32.9563 1.60213C32.5622 1.21659 32.0277 1 31.4704 1H3.1014C2.54408 1 2.00958 1.21659 1.61549 1.60213C1.2214 1.98767 1 2.51058 1 3.05581V39.0325C1 39.5778 1.2214 40.1007 1.61549 40.4862C2.00958 40.8717 2.54408 41.0883 3.1014 41.0883Z",
    stroke: "#0C89EF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8468 7.10629H22.6053M3.50562 3.50552H31.0664V10.7191H3.50562V3.50552ZM10.1385 14.5185V20.3091H3.50672V14.5185H10.1385ZM10.1374 23.6542V29.4449H3.50562V23.6542H10.1374ZM10.1374 32.7922V38.5828H3.50562V32.7922H10.1374ZM20.6024 14.5185V20.3091H13.9706V14.5185H20.6024ZM20.6013 23.6542V29.4449H13.9695V23.6542H20.6013ZM20.6013 32.7922V38.5828H13.9695V32.7922H20.6013ZM31.0664 14.5185V20.3091H24.4345V14.5185H31.0664ZM31.0652 23.6542V29.4449H24.4334V23.6542H31.0652ZM31.0652 32.7922V38.5828H24.4334V32.7922H31.0652Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3079 6.01104H28.5606V8.51656",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.e3cb5d367ebad44c40a1b5560854b06c.svg";
export { ForwardRef as ReactComponent };